import state from './module-criteria-setup-state';
import mutations from './module-criteria-setup-mutations';
import actions from './module-criteria-setup-actions';
import getters from './module-criteria-setup-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
